import React from "react";
import { Link } from "@tanstack/react-router";
import "./ProductHeroSection.css";
import { Button } from "@tennr/frontend/components/Button";
import { Heading } from "@tennr/frontend/components/Heading";

export const ProductHeroSection = () => {
  return (
    <section className="product-hero-section">
      <div className="product-hero-bg">
        <img
          className="product-hero-image"
          alt="Product hero"
          src="/img/product-hero-section-bg.svg"
          draggable={false}
        />
      </div>
      <div className="product-hero-overlap">
        <div className="product-hero-group">
          <div className="product-hero-overlap-group">
            <Heading
              title={"BEAT THE BOTTLENECKS"}
              heading={"Close operational gaps,\nspeed up patient care"}
              body={"Your team, referrers, payors, and patients will all feel the difference."}
              variant="hero"
              position="left"
              mobilePosition="left"
              verticalAlign="top"
            />
            <Link to="/book-a-demo">
              <Button text={"BOOK A DEMO"} minWidth={160} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
